import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {map, Observable, of} from 'rxjs';

const NUMBER_UNITS = ['thousand', 'million', 'billion', 'trillion'];

@Pipe({
    name: 'numberFormat',
    standalone: false
})
export class NumberFormat implements PipeTransform {
  constructor(private readonly translate: TranslateService) {
  }

  transform(value: number, long?: boolean): Observable<string> {
    let numericValue = Number(value);
    if (isNaN(numericValue)) {
      return of('');
    }
    if (numericValue == 0) {
      return of('');
    }
    let unit: number = Math.floor(Math.log(numericValue) / Math.log(1000));
    unit = Math.min(unit, NUMBER_UNITS.length);
    let amount = Math.round((numericValue / Math.pow(1000, unit) + Number.EPSILON) * 100) / 100;

    let amountWithComma = amount.toString().replace('.', ',');

    if (unit == 0) {
      return of(amount + '');
    }
    const size = long ? '.long' : '.short';
    return this.translate.get('numberUnit.' + NUMBER_UNITS[unit - 1] + size).pipe(map(unit => amountWithComma + ' ' + unit));
  }
}
